import { useEffect, useState } from 'react';

import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from "../firebase";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './work-log-history.css'; // custom style
import { MdSearch, MdAdd, MdSettings } from 'react-icons/md';
import Cookies from 'js-cookie';
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';


const Workloghistory = () => {
  const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
  const [value, setValue] = useState(new Date());

  const navigate = useNavigate();
  const today = new Date();

  const isToday = (date) => {
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    if (adminguid) {
      fetch_workData("no");
    }
  }, [adminguid]);
const [workdata, setworkdata] = useState({ W: 0, I: 0 });
const fetch_workData = async (date) => {
 let startDate;

  if (date && date !== "no" && !isNaN(new Date(date))) {
    startDate = new Date(date);
  } else {
    startDate = new Date();
  }

  startDate.setDate(1);
  startDate.setUTCHours(0, 0, 0, 0);

  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 1);
  endDate.setDate(0);
  endDate.setUTCHours(23, 59, 59, 999);

  const startTimestamp = Timestamp.fromDate(startDate);
  const endTimestamp = Timestamp.fromDate(endDate);

  try {
    const tQuery = query(
      collection(db, "projectstaskitemstatus"),
      where("adminguid", "==", adminguid),
      where("status", "==", true),
      where("date_time", ">=", startTimestamp),
      where("date_time", "<=", endTimestamp)
    );

    const tSnap = await getDocs(tQuery);

    const grouped = {};
    const dailyItemuids = {};

    tSnap.forEach(doc => {
      const data = doc.data();
      const dateObj = data.date_time?.toDate?.();
      if (!dateObj) return;

      const dateKey = dateObj.toISOString().split('T')[0]; // "YYYY-MM-DD"

      if (!grouped[dateKey]) {
        grouped[dateKey] = { W: 0, I: 0 };
        dailyItemuids[dateKey] = new Set();
      }

      // Sum status_complete
      if (typeof data.status_complete === 'number' && data.status_complete > 0) {
        grouped[dateKey].W += data.status_complete;
      }

      // Count unique itemuid per date
      if (data.itemuid && !dailyItemuids[dateKey].has(data.itemuid)) {
        dailyItemuids[dateKey].add(data.itemuid);
        grouped[dateKey].I++;
      }
    });

    setworkdata(grouped);

  } catch (error) {
    console.error("Error fetching work log:", error);
  }
};

const tileContent = ({ date }) => {
  const key = date.toISOString().split('T')[0]; // "YYYY-MM-DD"
  const data = workdata[key];

  if (data) {
    return (
      <div className="today-data">
        <div>{data.W} % </div>
        <div>{data.I} W</div>
      </div>
    );
  }
  return null;
};

  return (
    <>
      <div className="calendar-wrapper">
<Calendar
  className="calendar-body"
  onChange={(date) => {
    setValue(date);        // sets selected date
    fetch_workData(date);  // fetches data for that date
  }}
  value={value}
  onClickDay={(date) => {
    setValue(date);        // also handle here if needed
    fetch_workData(date);
  }}
  tileClassName={({ date }) =>
    isToday(date)
      ? 'bold-today'
      : date.toDateString() === value.toDateString()
        ? 'selected-date'
        : null
  }
  tileContent={tileContent}
/>
      </div>

      <div className='project-hd'>

        <MdSearch className='search-img' />
        <input className='proj-search-input' placeholder='Work History' />
        <MdSettings title='Settings' onClick={() => navigate('/work-history')} className='add-project-img' />
      </div>
      <div className='dashboard-grid'>
      </div>
    </>
  );
};

export default Workloghistory;
